/**
 * 命理分享連結的「可逆雜湊」編碼
 * 把 生日(YYYY-MM-DD) + 時辰 包成一個不可直接讀出的 token，
 * 前端用相同方式還原。非加密等級，只為避免生日明碼出現在網址。
 *
 *   encodeInsight({ type:'wuxing', d:'1990-05-15', t:10 }) -> 'd0F1...'
 *   decodeInsight('d0F1...') -> { type:'wuxing', d:'1990-05-15', t:10 }
 */

const KEY = 'shiningstars-星河';

function xorStr(s) {
  let out = '';
  for (let i = 0; i < s.length; i++) {
    out += String.fromCharCode(s.charCodeAt(i) ^ (KEY.charCodeAt(i % KEY.length) & 0xff));
  }
  return out;
}

function b64urlEncode(s) {
  // s 為 0~255 的位元組字串
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function b64urlDecode(s) {
  const pad = s.length % 4 === 0 ? '' : '='.repeat(4 - (s.length % 4));
  return atob(s.replace(/-/g, '+').replace(/_/g, '/') + pad);
}

export function encodeInsight({ type, d, t }) {
  if (!d) return '';
  const tp = type === 'wuxing' ? 'w' : 'n';
  const ymd = String(d).replace(/-/g, ''); // YYYYMMDD
  const hr = t === null || t === undefined || t === '' ? '' : String(t);
  const payload = `${tp}${ymd}${hr !== '' ? '.' + hr : ''}`;
  return b64urlEncode(xorStr(payload));
}

export function decodeInsight(code) {
  try {
    const payload = xorStr(b64urlDecode(code));
    const tp = payload[0];
    if (tp !== 'w' && tp !== 'n') return null;
    const [ymd, hr] = payload.slice(1).split('.');
    if (!/^\d{8}$/.test(ymd)) return null;
    const d = `${ymd.slice(0, 4)}-${ymd.slice(4, 6)}-${ymd.slice(6, 8)}`;
    const type = tp === 'w' ? 'wuxing' : 'numerology';
    const t = hr !== undefined && hr !== '' ? parseInt(hr, 10) : null;
    return { type, d, t };
  } catch {
    return null;
  }
}
